import { useEffect, useState } from 'react'
import { TaskParams } from '~/components/task-forms/BaseTaskForm'
import RadioGroup from '~/components/common/RadioGroup'
import { AgentRequest } from '~/protos/agents'

interface DiagramGeneratorFormProps {
  onChange?: (task: TaskParams) => void
  setIsMultiSelect: (isMultiSelect: boolean) => void
  withExamplePrefilled?: boolean
  initialDiagramType?: 'sequence' | 'flow'
}

export function DiagramGeneratorForm({
  onChange,
  setIsMultiSelect,
  withExamplePrefilled,
  initialDiagramType
}: DiagramGeneratorFormProps) {
  // Initialize with initialDiagramType if provided, otherwise default to 'sequence'
  const [diagramType, setDiagramType] = useState<'sequence' | 'flow'>(
    initialDiagramType || 'sequence'
  )

  // Handle initialDiagramType changes (for editing tasks)
  useEffect(() => {
    if (initialDiagramType) {
      setDiagramType(initialDiagramType)
    }
  }, [initialDiagramType])

  // If withExamplePrefilled is true, set the request to generate a flow diagram
  useEffect(() => {
    if (withExamplePrefilled != null && withExamplePrefilled) {
      setDiagramType('flow')
    }
  }, [withExamplePrefilled])

  useEffect(() => {
    // Set multiselect mode based on diagram type
    setIsMultiSelect(diagramType === 'sequence')

    // Update task params when diagram type changes
    if (onChange) {
      onChange({
        request: AgentRequest.fromPartial({
          generateSeqDiag: diagramType === 'sequence',
          generateFlowDiag: diagramType === 'flow'
        })
      })
    }
  }, [diagramType, onChange, setIsMultiSelect])

  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDiagramType(e.target.value as 'sequence' | 'flow')
  }

  const radioOptions = [
    { label: 'Sequence Diagram', value: 'sequence' },
    { label: 'Flow Diagram', value: 'flow' }
  ]

  return (
    <div className='space-y-4'>
      <div className='text-sm font-semibold text-default-700 mb-1 select-none'>Diagram Type:</div>
      <RadioGroup
        isDisabled={withExamplePrefilled}
        options={radioOptions}
        onChange={handleRadioChange}
        defaultValue={diagramType}
        id='diagram-type'
      />
    </div>
  )
}
